import { ClientRequestBase } from "./client_request_base.js";

export class SessionUpdateRequest extends ClientRequestBase
{
  constructor( public payload: Record<string, unknown> )
  {
    super();
  }
}
